import { IssueCategory } from "types/issueCategory";
import { Media } from "types/media";

export enum IssueStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
}

export const IssueStatusTrans = {
  [IssueStatus.PENDING]: {
    value: IssueStatus.PENDING,
    label: "Chờ xử lý",
    color: "orange",
  },
  [IssueStatus.PROCESSING]: {
    value: IssueStatus.PROCESSING,
    label: "Đang xử lý",
    color: "blue",
  },
  [IssueStatus.COMPLETED]: {
    value: IssueStatus.COMPLETED,
    label: "Đã xử lý",
    color: "green",
  },
  [IssueStatus.REJECTED]: {
    value: IssueStatus.REJECTED,
    label: "Từ chối",
    color: "red",
  },
};

export interface Issue {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  code: string;
  title: string;
  description: string;
  status: string;
  priority: string;
  closeType: string;
  latitude: number;
  longitude: number;
  accuracy: number;
  address: string;
  reporterName: string;
  reporterPhone: string;
  reportImages: string | Media[];
  resolvedImages: string | Media[];
  resolvedAt: number;
  issueCategory: IssueCategory;
  issueCategoryId: number;
  reason: string;
  note: string;
}

export interface IssueLog {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  action: string;
  status: string;
  note: string;
  metadata: string;
  issue: Issue;
}
